import { render, staticRenderFns } from "./createTournament.vue?vue&type=template&id=970d52ec&"
import script from "./createTournament.vue?vue&type=script&lang=js&"
export * from "./createTournament.vue?vue&type=script&lang=js&"
import style0 from "./createTournament.vue?vue&type=style&index=0&id=970d52ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports